// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Wrapper for the entire lens + details */
.ai-lens-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    max-width: 360px;
    font-size: 0.85rem;
    margin-top: 4px;
}

/* Wrapper around the chip to hold the orbit effect */
.ai-lens-chip-container {
    position: relative;
    display: inline-block;
}

/* The clickable AI Lens button */
.ai-lens-chip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 12px;
    background: #f6f6f6; /* neutral tone */
    color: #2e7d32;
    border: 1px solid #c0c0c0;
    border-radius: 999px;
    font-weight: 600;
    cursor: pointer;
    font-size: 0.8rem;
    transition: background 0.3s ease;
    outline: none;
    border: none;
}

    .ai-lens-chip:hover {
        background: #ececec;
        box-shadow: 0 0 4px rgba(46, 125, 50, 0.3);
    }

/* Icon on the left */
.icon {
    font-size: 16px;
}

/* "AI Lens" label */
.label {
    font-weight: 600;
}

/* Expand / Collapse icon */
.expand-icon {
    font-size: 16px;
    color: #2e7d32;
}

/* Animated orbit glow indicator (top right) */
.ai-orbit-indicator {
    position: absolute;
    top: -6px;
    right: -6px;
    width: 12px;
    height: 12px;
    background-color: #43a047;
    border-radius: 50%;
    box-shadow: 0 0 0 rgba(67, 160, 71, 0.4);
    animation: orbitGlow 2s infinite ease-in-out;
    z-index: 1;
    pointer-events: none;
}

/* Orbit glow keyframe */
@keyframes orbitGlow {
    0% {
        box-shadow: 0 0 0 0 rgba(67, 160, 71, 0.4);
    }

    70% {
        box-shadow: 0 0 0 10px rgba(67, 160, 71, 0);
    }

    100% {
        box-shadow: 0 0 0 0 rgba(67, 160, 71, 0);
    }
}

/* Expanded explanation section */
.ai-lens-details {
    margin-top: 8px;
    background: #f9fcff;
    border-left: 3px solid #43a047;
    padding: 8px 12px;
    border-radius: 6px;
    color: #333;
    font-size: 0.8rem;
    line-height: 1.5;
    width: 100%;
    animation: fadeIn 0.2s ease-in-out;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(-4px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/AI/AIExplainChip.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;;AAEA,qDAAqD;AACrD;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA,iCAAiC;AACjC;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,mBAAmB,EAAE,iBAAiB;IACtC,cAAc;IACd,yBAAyB;IACzB,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gCAAgC;IAChC,aAAa;IACb,YAAY;AAChB;;IAEI;QACI,mBAAmB;QACnB,0CAA0C;IAC9C;;AAEJ,qBAAqB;AACrB;IACI,eAAe;AACnB;;AAEA,oBAAoB;AACpB;IACI,gBAAgB;AACpB;;AAEA,2BAA2B;AAC3B;IACI,eAAe;IACf,cAAc;AAClB;;AAEA,8CAA8C;AAC9C;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,wCAAwC;IACxC,4CAA4C;IAC5C,UAAU;IACV,oBAAoB;AACxB;;AAEA,wBAAwB;AACxB;IACI;QACI,0CAA0C;IAC9C;;IAEA;QACI,2CAA2C;IAC/C;;IAEA;QACI,wCAAwC;IAC5C;AACJ;;AAEA,iCAAiC;AACjC;IACI,eAAe;IACf,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,kCAAkC;AACtC;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ","sourcesContent":["/* Wrapper for the entire lens + details */\n.ai-lens-wrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    max-width: 360px;\n    font-size: 0.85rem;\n    margin-top: 4px;\n}\n\n/* Wrapper around the chip to hold the orbit effect */\n.ai-lens-chip-container {\n    position: relative;\n    display: inline-block;\n}\n\n/* The clickable AI Lens button */\n.ai-lens-chip {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 6px 12px;\n    background: #f6f6f6; /* neutral tone */\n    color: #2e7d32;\n    border: 1px solid #c0c0c0;\n    border-radius: 999px;\n    font-weight: 600;\n    cursor: pointer;\n    font-size: 0.8rem;\n    transition: background 0.3s ease;\n    outline: none;\n    border: none;\n}\n\n    .ai-lens-chip:hover {\n        background: #ececec;\n        box-shadow: 0 0 4px rgba(46, 125, 50, 0.3);\n    }\n\n/* Icon on the left */\n.icon {\n    font-size: 16px;\n}\n\n/* \"AI Lens\" label */\n.label {\n    font-weight: 600;\n}\n\n/* Expand / Collapse icon */\n.expand-icon {\n    font-size: 16px;\n    color: #2e7d32;\n}\n\n/* Animated orbit glow indicator (top right) */\n.ai-orbit-indicator {\n    position: absolute;\n    top: -6px;\n    right: -6px;\n    width: 12px;\n    height: 12px;\n    background-color: #43a047;\n    border-radius: 50%;\n    box-shadow: 0 0 0 rgba(67, 160, 71, 0.4);\n    animation: orbitGlow 2s infinite ease-in-out;\n    z-index: 1;\n    pointer-events: none;\n}\n\n/* Orbit glow keyframe */\n@keyframes orbitGlow {\n    0% {\n        box-shadow: 0 0 0 0 rgba(67, 160, 71, 0.4);\n    }\n\n    70% {\n        box-shadow: 0 0 0 10px rgba(67, 160, 71, 0);\n    }\n\n    100% {\n        box-shadow: 0 0 0 0 rgba(67, 160, 71, 0);\n    }\n}\n\n/* Expanded explanation section */\n.ai-lens-details {\n    margin-top: 8px;\n    background: #f9fcff;\n    border-left: 3px solid #43a047;\n    padding: 8px 12px;\n    border-radius: 6px;\n    color: #333;\n    font-size: 0.8rem;\n    line-height: 1.5;\n    width: 100%;\n    animation: fadeIn 0.2s ease-in-out;\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(-4px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
